<template>
  <v-img
    class="mx-2"
    src="/logo-big-recortado.png"
    max-width="500"
    data-testid="home-page-logo"
  />
</template>
